import { render, staticRenderFns } from "./SocialMarketing.vue?vue&type=template&id=27069695&scoped=true"
import script from "./SocialMarketing.vue?vue&type=script&lang=js"
export * from "./SocialMarketing.vue?vue&type=script&lang=js"
import style0 from "./SocialMarketing.vue?vue&type=style&index=0&id=27069695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27069695",
  null
  
)

export default component.exports